import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import StyledLink from '../../../components/StyledLink';
import { Account } from '../../../types/management-auth';
import { Settlement } from '../types';

export interface VippsGuideProps {
    settlements: Settlement[];
    account: Account | undefined;
    accountId: string;
    isLoading: boolean;
    queryParams: URLSearchParams;
}

export const VippsGuide = (
    {
        queryParams,
        isLoading,
        accountId,
        account,
        settlements,
    }: VippsGuideProps
) => {
    const { t } = useTranslation();
    const vippsEnabled =
        account && account.connections && account.connections.vipps && account.connections.vipps.status === 'enabled';
    const hasVippsSettlements = settlements.some((settlement) => settlement.provider === 'vipps');
    const paymentProviderFilter = queryParams.getAll('payment_provider');
    const hasFilteredAwayVipps = paymentProviderFilter.length > 0 && !paymentProviderFilter.includes('vipps');
    const settlementEmail = `${accountId.substr(1)}@settlements.dintero.com`;

    const showVippsGuide = !isLoading && vippsEnabled && !hasVippsSettlements && !hasFilteredAwayVipps;
    if (!showVippsGuide) {
        return null;
    }
    return (
        <Info>
            <h4>{t('settlements.help.vipps.title')}</h4>
            <p>
                <Trans i18nKey={'settlements.help.vipps.content'} values={{ email: settlementEmail }}>
                    <StyledLink
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://docs.dintero.com/docs/checkout/checkout-vipps-settlements/"
                    />
                    <Email />
                </Trans>
            </p>
        </Info>
    );
};

const Info = styled.div`
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 0;
    h4 {
        margin: 0;
    }
    p {
        margin: 0;
    }
`;


const Email = styled.span`
    font-weight: bold;
`;
